module.exports = __webpack_public_path__ + "img/login-fon-img.1ed8c960.png";